// Port of api/fuel/app/classes/filter/package/games/play/package/players.php
export default {
	require: function(config, filter) { return !filter.play || !filter.play.group },
	run: function(pkg, local, global) {
		var play = local.result || {}
		var players = []
		var keyedExistingPlayers = global.players && global.players.exist ? global.players.exist : {}
		pkg.players = []

		if (parseInt(play.play_players || 0, 10) && global.players && global.players.plays && global.players.plays[local.id]) {
			players = global.players.plays[local.id]
		}

		pkg.players = players.map(function(player) {
			var id = parseInt(player.user_id || 0, 10)
			if (id && !keyedExistingPlayers[id]) id = 0
			return {
				id: id,
				name: player.player_name || '',
				color: String(player.player_color || '').toLowerCase(),
				score: parseInt(player.player_score || 0, 10),
				win: parseInt(player.player_win || 0, 10)
			}
		})
		return pkg
	}
}
